import { Suspense } from 'react';
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import { Menu } from "./Menu/menu";
import { Footer } from "./Footer/footer";
import { ErrorBoundary } from "../../../Common/ErrorBoundary/errorBoundary";
import { SimpleLoader } from "../../../Common/Loader/simpleLoader";
import { themeContent } from "../../../../Themes/themes";

export function Layout(props) {
    return (
        <ThemeProvider theme={themeContent}>
            <div>
                <Menu {...props} />
                <ErrorBoundary>
                    <Suspense fallback={<SimpleLoader />}>
                        <Outlet />
                    </Suspense>
                </ErrorBoundary>
                <Footer {...props} />
            </div>
        </ThemeProvider>
    );
}